import {get, post} from '@/utils/request';

// 登陆页获取北京图片
export const loginPlatform = (params = {}) => get('/user/platform/domain', params)
// 修改密码
export const changePassWord = (params = {}) => post('/user/password', params)

//系统管理-用户管理
export const userList = (params = {}) => post('/user/list', params)
//部门树
export const deptTreeSelect = (params = {}) => get('/user/deptTreeSelect', params)
// 用户详情
export const getUser = (params = {}) => get('/user/getUser', params)
//修改用户状态
export const changeUserStatus = (params = {}) => post('/user/changeStatus', params)
// 新增用户
export const saveUser = (params = {}) => post('/user/saveUser', params)
// 新增员工时获取角色
export const userRole = (params = {}) => get('/user/userRole', params)

// 编辑后的保存
export const updateUser = (params = {}) => post('/user/updateUser', params)

// 用户和代理商列表
export const userAgentList = (params = {}) => get('/user/userAgent', params)
// 重置密码
export const restPassword = (params = {}) => get('/user/restPassword', params)
//用户分配角色
export const authRole = (params = {}) => get('/user/authRole', params)
//用户授权
export const updateAuthRole = (params = {}) => post('/user/updateAuthRole', params)
//用户删除
export const delUser = (params = {}) => post('/user/deleteUser', params)


//根据角色获取用户
export const usersRoleType = (params = {}) => get('/user/usersRoleType', params)
//业务员分页列表
export const usersSalemans = (params = {}) => post('/salesman/page', params)
//业务员列表
export const usersSalemansList = (params = {}) => post('/salesman/list', params)

//系统管理-菜单管理
export const listModule = (params = {}) => get('/module/list', params)
export const saveModule = (params = {}) => post('/module/save', params)
export const updateModule = (params = {}) => post('/module/edit', params)
export const getModule = (params = {}) => get('/module/getModule', params)
export const delModule = (params = {}) => get('/module/delete', params)

export const moduleTreeSelect = (params = {}) => get('/module/moduleTreeSelect', params)
export const roleModuleTreeSelect = (params = {}) => get('/module/roleModuleTreeSelect', params)

//系统管理-角色管理
export const listRole = (params = {}) => post('/role/list', params)
// 新增角色
export const addRole = (params = {}) => post('/role/save', params)
// 编辑角色初始化数据
export const getRole = (params = {}) => get('/role/getRole', params)
// 编辑角色提交
export const updateRole = (params = {}) => post('/role/updateRole', params)
// 删除角色
export const delRole = (params = {}) => post('/role/delRole', params)

export const dataDeptScope = (params = {}) => post('/role/dataDeptScope', params)

// 已分配用户角色
export const allocatedUserList = (params = {}) => post('/role/allocatedList', params)
// 未分配用户角色
export const unallocatedUserList = (params = {}) => post('/role/unallocatedUserList', params)

// 取消用户授权
export const authUserCancel = (params = {}) => post('/role/authUser/cancel', params)
// 批量取消用户授权
export const authUserCancelAll = (params = {}) => post('/role/authUser/cancelAll', params)

// 批量用户授权
export const authUserSelectAll = (params = {}) => post('/role/authUser/selectAll', params)

export const listRoleTemplate = (params = {}) => post('/role/template/list', params)

export const updateTemplate = (params = {}) => post('/role/template/updateTemplate', params)

export const roleTemplateMenuIds = (params = {}) => get('/role/template/menuIds', params)

//修改角色状态
export const changeRoleStatus = (params = {}) => post('/role/changeRoleStatus', params)
//角色部门权限
export const roleDeptTreeSelect = (params = {}) => get('/role/deptTreeSelect', params)
//数据范围选项
export const dataScopeOptions = (params = {}) => get('/role/dataScopeOptions', params)


//系统管理-部门管理
export const listDept = (params = {}) => post('/sys/dept/list', params)
export const getDept = (params = {}) => get('/sys/dept/getInfo', params)
export const delDept = (params = {}) => get('/sys/dept/delete', params)
export const addDept = (params = {}) => post('/sys/dept/save', params)
export const updateDept = (params = {}) => post('/sys/dept/update', params)
export const listDeptExcludeChild = (params = {}) => get('/sys/dept/listExcludeId', params)

//系统管理-岗位管理
export const listPost = (params = {}) => post('/sys/post/list', params)
export const getPost = (params = {}) => get('/sys/post/getInfo', params)
export const delPost = (params = {}) => post('/sys/post/delete', params)
export const addPost = (params = {}) => post('/sys/post/save', params)
export const updatePost = (params = {}) => post('/sys/post/update', params)

//系统管理-支付管理
export const listPay = (params = {}) => post('/pay/config/page', params)
//系统管理-支付投诉回调配置
export const complaintNotify = (params = {}) => get('/pay/config/complaintNotify', params)
//系统管理-支付投诉刷新
export const refreshComplaint = (params = {}) => get('/pay/config/refreshComplaint', params)



// 事业部组
export const divisionDept = (params = {}) => post('/sys/dept/list', params)

// 首页运营商的流量统计
export const monthFlow = (params = {}) => get('/statistic/monthFlow', params)
// 首页卡源月流量统计
export const sourceMonthFlow = (params = {}) => get('/statistic/sourceMonthFlow', params)

// 首页卡源月流量统计
export const monthFlowOperator = (params = {}) => get('/statistic/monthFlowOperator', params)
// 首页top5
export const todayTopCard = (params = {}) => get('/statistic/todayTopCard', params)
// 首页卡激活停机折线图
export const cardStopActiveLineChart = (params = {}) => get('/statistic/cardStopActiveLine', params)
// 首页状态饼图
export const cardSourceHash = (params = {}) => get('/statistic/cardSourceHash', params)
// 小流量的数据
export const smallCardPoolUse = (params = {}) => get('/statistic/smallCardPoolUse', params)
// 小流量的饼图
export const smallCardStatusCount = (params = {}) => get('/statistic/smallCardStatusCount', params)
// 小流量的假饼图
export const smallCardShowStatusPoolUse = (params = {}) => get('/statistic/smallCardShowStatusPoolUse', params)
//sideBar数据
export const module = (params = {}) => get('/module', params)
// 获取权限
export const permission = (params = {}) => get('/module/permission', params)


// 个人中心获取数据
export const userInfo = (params = {}) => get('/person/userInfo', params)
// 系统充值
export const recharge = (params = {}) => post('/person/recharge', params)
// 发送验证码
export const sendSms = (params = {}) => post('/sms/sendSms', params)

//企业认证短信
export const userCertSms = (params = {}) => get('/sms/userCert', params)

// 重新绑定手机号
export const bindPhone = (params = {}) => post('/person/bindPhone', params)


//微信支付生成订单号
export const createOrder = (params = {}) => post('/wx/pay/createOrder', params)
//流量池－扫码支付
export const poolCreateOrder = (params = {}) => post('/pay/pool/createOrder', params)

// 绑定微信生成二维码
export const createQrCodeBindWx = (params = {}) => post('/wx/bind/qrcode', params)
// 微信支付生成二维码
export const createQrCodeOrder = (params = {}) => post('/wx/pay/createQrCodeOrder', params)
// 微信支付查询状态
export const queryQrCodeOrder = (params = {}) => get('/wx/pay/queryQrCodeOrder', params)
// 流量池－微信支付生成二维码
export const createPoolQrCodeOrder = (params = {}) => post('/pay/pool/createQrCodeOrder', params)
//流量池－支付查询状态
export const poolQueryOrderStatus = (params = {}) => get('/pay/pool/queryOrderStatus', params)
// 流量池－微信支付查询状态-加油包
export const poolQueryQrCodeOrder = (params = {}) => get('/pay/pool/queryQrCodeOrder', params)
// 流量池－微信支付查询状态-续费
export const poolQueryQrCodeOrderByRenewal = (params = {}) => get('/pay/pool/queryQrCodeOrderByRenewal', params)

// 微信扫二维码绑定
export const qrcode = (params = {}) => get('/wx/bind/qrcode', params)
// 微信扫二维码绑定查询状态
export const result = (params = {}) => get('/wx/bind/result', params)
// 个人中心的充值记录
export const chargeRecord = (params = {}) => post('/wx/pay/chargeRecord', params)
// 获取代理商查询
export const agentList = (params = {}) => get('/agent/agentList', params)

// 获取代理商查询
export const agentDataList = (params = {}) => post('/agent/agentList', params)

//代理商账户金额查询
export const agentUserAsset = (params = {}) => get('/agent/agentUserAsset', params)

// 企业认证列表
export const kycList = (params = {}) => post('/kyc/kycList', params)
// 认证详情
export const kycDetail = (params = {}) => get('/kyc/kycDetail', params)
// 更改认证状态
export const changeKycRecordStatus = (params = {}) => post('/kyc/changeKycRecordStatus', params)
// 用户认证信息
export const userKyc = (params = {}) => post('/kyc/userKyc', params)
//实名信息查询
export const userAuthenticationInfo = (params = {}) => get('/kyc/userAuthenticationInfo', params)
//实名信息修改
export const updateUserAuthentication = (params = {}) => post('/kyc/updateUserAuthentication', params)

// 用户账户明细
export const accountList = (params = {}) => post('/user/asset/accountList', params)
// 用户账户明细导出
export const exportAccount = (params = {}) => post('/user/asset/exportAccount', params)
// 用户查看成功失败的卡数
export const assetCardList = (params = {}) => post('/user/asset/cardList', params)
// 用户查看成功失败的卡数的导出
export const assetInfoExport = (params = {}) => post('/user/asset/infoExport', params)
// 用户账户代理商余额
export const assetStatistical = (params = {}) => post('/user/asset/statistical', params)
// 用户提现记录
export const record = (params = {}) => post('/user/withdrawal/record', params)
// 用户提现审核 
export const optionalStatus = (params = {}) => post('/user/withdrawal/optionalStatus', params)
// 用户提现生成订单
export const orderlist = (params = {}) => post('/user/withdrawal/order', params)
// 分润提现的金额微信绑定状态
export const userAccountMoney = (params = {}) => post('/person/userAccountMoney', params)
// 添加银行卡的认证
export const saveUserBank = (params = {}) => post('/user/bank/saveUserBank', params)

// 修改银行卡的认证
export const updateUserBank = (params = {}) => post('/user/bank/updateUserBank', params)
// 获取银行卡列表
export const bankList = (params = {}) => post('/user/bank/list', params)
// 银行卡认证列表
export const listPage = (params = {}) => post('/user/bank/listPage', params)
// 修改银行认证状态
export const updateStatus = (params = {}) => post('/user/bank/updateStatus', params)
// 修改银行认证状态
export const bankdetail = (params = {}) => get('/user/bank/detail', params)
// 设置套餐充值密码
export const setPayPassword = (params = {}) => post('/user/setPayPassword', params)
// 修改套餐充值密码
export const changePayPassword = (params = {}) => post('/user/changePayPassword', params)

// 代理管理 - 代理商
// 代理商分页列表
export const agentListsData = (params = {}) => post('/agent/list', params)
// 获取代理商编辑时的详情
export const agentDetail = (params = {}) => get('/agent/getAgentDetail', params)
//获取代理商详情
export const agentInfo = (params = {}) => get('/agent/agentInfo', params)
// 创建代理商
export const agentSave = (params = {}) => post('/agent/agentSave', params)
// 修改代理商
export const agentUpdate = (params = {}) => post('/agent/update', params)
//代理商设置套餐
export const agentCustomProduct = (params = {}) => post('/agent/customProduct', params)
//代理商参数设置
export const agentDictList = (params = {}) => get('/agentDict/list', params)
//代理商参数删除
export const agentDictDel = (params = {}) => get('/agentDict/del', params)
//代理商参数修改
export const agentDictUpdate = (params = {}) => post('/agentDict/update', params)
//代理商参数保存
export const agentDictSave = (params = {}) => post('/agentDict/save', params)

//代理商设置套餐
export const customInternationalProduct = (params = {}) => post('/agent/customInternationalProduct', params)

//代理商设置自定义套餐价格
export const saveCustomProducts = (params = {}) => post('/agent/saveCustomProducts', params)

//代理商设置自定义套餐价格
export const saveCustomInternationalProducts = (params = {}) => post('/agent/saveCustomInternationalProducts', params)

//代理商设置自定义套餐价格删除
export const customProductCancel = (params = {}) => get('/agent/customProductCancel', params)

// 代理商树形结构查询
export const agentTreeList = (params = {}) => get('/agent/agentTreeList', params)

//代理商api文档
export const apiAgent = (params = {}) => get('/agent/apiAgent', params)

// 流量卡管理- 卡列表
// 卡导入的卡类型、卡要求、网络、运营商等基本信息
export const cardBaseInfo = (params = {}) => get('/card/cardBaseInfo', params)
// 卡导入输入运营商查询卡源
export const cardSource = (params = {}) => post('/card/cardSource', params)
// 提交运营商出现对应的卡源
export const cardSourceSelectList = (params) => post('card/cardSourceSelectList', params)
// 上传导入的信息
export const importCard = (params = {}) => post('/card/importCard', params)
// 卡列表
export const cardList = (params = {}) => post('/card/cardList', params)
// 卡列表导出
export const exportCard = (params = {}) => post('/card/exportCard', params)
// 卡列表备注
export const saveRemark = (params = {}) => post('/card/saveRemark', params)

//批量修改卡运营商状态
export const batchUpdateCarrierStatus = (params) => post('card/batchUpdateCarrierStatus', params)

// 卡源列表
export const cardSourceList = (params = {}) => post('/cardSource/list', params)
//运营商列表
export const operationList = (params) => post('card/operationList', params)
// 卡源流量列表
export const cardSourceFlowList = (params = {}) => post('/cardSource/flow/list', params)
// 卡源流量刷新
export const sourceFlowRefresh = (params = {}) => get('/cardSource/flow/refresh', params)
//共享卡源
export const sourceShareFlow = (params = {}) => get('/cardSource/flow/share', params)
export const selectCardSourceFlow = (params = {}) => get('/cardSource/selectCardSourceFlow', params)


// 获取卡详情
export const getCardSource = (params = {}) => get('/cardSource/detail', params)
export const addCardSource = (params = {}) => post('/cardSource/save', params)
export const updateCardSource = (params = {}) => post('/cardSource/update', params)

export const cardExist = (params = {}) => get('/card/cardExist', params)

export const updateCardCountry = (params = {}) => get('/card/updateCardCountry', params)

// 卡分配
export const assignCard = (params = {}) => post('/card/assignCard', params)
// 卡回收
export const cardRecycling = (params = {}) => post('/card/cardRecycling', params)
// 二维码导出
export const qrCardExport = (params = {}) => post('/card/qrCardExport', params)
// 卡批量更新
export const cardBatchSyncCard = (params = {}) => post('/card/batchSyncCard', params)

// 卡批量清除
export const removalCard = (params = {}) => post('/card/removalCard', params)
// 单卡清除
export const removalCardByIccid = (params = {}) => get('/card/removalCardByIccid', params)

//卡清除操作列表
export const cardRemovalRecord = (params) => post('/card/removalRecord', params)

//卡定向修改
export const batchOrientationSetting = (params) => post('/card/batchOrientationSetting', params)

//统计卡数量
export const selectCount = (params) => post('/card/selectCount', params)

// 限速
export const speedLimitRateList = (params = {}) => get('/card/getSpeedLimitRateList', params)
// 卡限速
export const speedCard = (params = {}) => post('/card/speedCard', params)
// 卡详情
export const cardDetail = (params = {}) => get('/card/cardDetail', params)
//重置卡标签
export const resetCardLabel = (params = {}) => get('/card/resetCardLabel', params)
// 卡详情的资费列表
export const cardProduct = (params = {}) => get('/card/cardProduct', params)
// 卡语音套餐列表
export const cardVoiceProduct = (params = {}) => get('/card/cardVoiceProduct', params)
// 卡短信套餐管理
export const cardSmsProduct = (params = {}) => get('/card/cardSmsProduct', params)
// 卡详情的订单列表
export const cardOrder = (params = {}) => get('/card/cardOrder', params)
// 卡详情的操作记录
export const cardOperation = (params = {}) => post('/card/cardOperation', params)
// 卡清除的操作记录
export const cardRemovalOperation = (params = {}) => post('/card/cardRemovalOperation', params)
// 卡详情的积分列表
export const cardIntegralRecord = (params = {}) => get('/card/cardIntegralRecord', params)
// 卡详情修改同步状态
export const changeCardSyncStatus = (params = {}) => post('/card/changeCardSyncStatus', params)
// 卡详情立即更新
export const syncCard = (params = {}) => post('/card/syncCard', params)
// 卡详情立即刷新
export const syncCardFlow = (params = {}) => post('/card/syncCardFlow', params)
// 卡详情修改假状态
export const changeCardShowStatus = (params = {}) => post('/card/changeCardShowStatus', params)
// 卡详情获取日月的流量详情
export const lineChartCardFlow = (params = {}) => get('/statistic/lineChartCardFlow', params)

// 卡详情开关gprs
export const changeCardNetStatus = (params = {}) => post('/card/changeCardNetStatus', params)
// 卡详情开关限速
export const changeCardSpeedStatus = (params = {}) => post('/card/changeCardSpeedStatus', params)
// 卡详情开关机
export const changeCardStatus = (params = {}) => post('/card/changeCardStatus', params)
// 批量操作卡备注
export const batchCardRemark = (params = {}) => post('/card/batchCardRemark', params)
// 卡详情-刷新运营状态
export const syncRefreshCardStatus = (params = {}) => get('/card/refreshCardStatus', params)
// 卡详情-刷新IMEI
export const syncRefreshImei = (params = {}) => get('/card/refreshImei', params)
// 卡详情-刷新GPRS
export const syncRefreshGprsStatus = (params = {}) => get('/card/refreshGprsStatus', params)
// 卡详情-刷新当月流量
export const syncRefreshMonthFlow = (params = {}) => get('/card/refreshMonthFlow', params)
// 卡详情-刷新在线状态
export const syncRefreshOnline = (params = {}) => get('/card/refreshOnline', params)

// 卡详情-刷新停机冻结状态
export const refreshStopRestartStatus = (params = {}) => get('/card/refreshStopRestartStatus', params)

// 卡详情-刷新诊断信息
export const refreshDiagnosticResults = (params = {}) => get('/card/refreshDiagnosticResults', params)
// 卡详情-获取诊断信息
export const getDiagnosticResults = (params = {}) => get('/card/diagnosticResults', params)
// 补卡列表
export const changeList = (params = {}) => post('/card/change/list', params)
// 补卡备注
export const changeSaveRemark = (params = {}) => post('/card/change/saveRemark', params)
// 补卡发送短信
export const changePushMessage = (params = {}) => get('/card/change/pushMessage', params)
// 补卡导出
export const exportCardChange = (params = {}) => post('/card/change/exportCardChange', params)

export const batchRefreshCard = (params = {}) => post('/card/refreshCardGPRS', params)

// 获取补卡详情
export const getChangeDetail = (params = {}) => get('/card/change/getChangeDetail', params)
//提交补卡信息
export const updateCardChange = (params = {}) => post('/card/change/updateCardChange', params)

// 批量卡设置参数 
export const batchCardSetting = (params = {}) => post('/card/batchCardSetting', params)
//卡限制国家
export const cardCountries = (params = {}) => get('/card/cardCountries', params)

//运营商卡历史月流量
export const carrierCardFlowMonth = (params = {}) => get('/card/carrierCardFlowMonth', params)

//运营商卡历史日流量
export const carrierCardFlowDay = (params = {}) => get('/card/carrierCardFlowDay', params)

// 创建套餐
export const addProduct = (params = {}) => post('/product/addProduct', params)
// 套餐列表分页
export const productPage = (params = {}) => post('/product/productPage', params)

// 基础套餐列表分页
export const commonProductPage = (params = {}) => post('/product/commonProductPage', params)

// 套餐加价列表
export const productExtraPricePage = (params = {}) => post('/user/extraProduct/index', params)

// 套餐加价
export const addProductExtraPrice = (params = {}) => post('/product/addProductExtraPrice', params)

// 套餐是否加价
export const markupProduct = (params = {}) => get('/product/markupProduct', params)

// 套餐加价费率
export const productExtraPriceRate = (params = {}) => get('/product/productExtraPriceRate', params)

export const getUserProductPrice = (params = {}) => get('/product/getUserProductPrice', params)
//修改自定义套餐
export const updateUserProductPrice = (params = {}) => post('/product/updateUserProductPrice', params)

//修改套餐限速规则
export const updateProductSpeedRule = (params = {}) => post('/product/updateProductSpeedRule', params)

//移除套餐限速规则
export const delProductSpeedRule = (params = {}) => get('/product/delProductSpeedRule', params)

//获取套餐绑定的代理商 
export const selectAgentByProduct = (params = {}) => get('/product/selectAgentByProduct', params)


// 国家运营商列表
export const operatorList = (params = {}) => get('/operator/list', params)
// 套餐类型列表
export const productType = (params = {}) => get('/product/productType', params)

//套餐管理 - 套餐列表
//基础套餐列表
export const basicProductPage = (params = {}) => post('/product/basicProductPage', params)
// 编辑套餐获取详情
export const getProduct = (params = {}) => get('/product/getProduct', params)
// 更新套餐
export const updateProduct = (params = {}) => post('/product/updateProduct', params)
//查找套餐可使用区域
export const selectInternationalGroup = (params = {}) => get('/product/selectInternationalGroup', params)
//套餐管理 - 套餐组
// 套餐组不分页套餐列表
export const productList = (params = {}) => post('/product/productList', params)
// 新建套餐组
export const addProductGroup = (params = {}) => post('/product/addProductGroup', params)
// 列表带分页的套餐组
export const productGroupPage = (params = {}) => post('/product/productGroupPage', params)
// 获取套餐组详情
export const productGroupInfo = (params = {}) => get('/product/productGroupInfo', params)
// 更新套餐组
export const updateProductGroup = (params = {}) => post('/product/updateProductGroup', params)
// 套餐组列表
export const productGroup = (params = {}) => get('/product/productGroup', params)


// 新建底价套餐
export const addBaseProduct = (params = {}) => post('/baseProduct/addBaseProduct', params)
// 代理商单级查询
export const agentSingleList = (params = {}) => get('/agent/agentSingleList', params)
// 底价套餐列表
export const baseProductPage = (params = {}) => post('/baseProduct/productPage', params)
// 编辑低价保存数据
export const updateBaseProduct = (params = {}) => post('/baseProduct/updateBaseProduct', params)
// 编辑低价获取数据
export const baseProductInfo = (params = {}) => get('/baseProduct/baseProductInfo', params)
// 底价套餐列表01
export const selectProductList = (params = {}) => get('/product/selectProductList', params)
// 底价套餐选择套餐id 出现对应的数据
export const getParentBaseProductInfo = (params = {}) => get('/baseProduct/getParentBaseProductInfo', params)

// 赠送套餐列表分页
export const productFreePage = (params = {}) => post('/productFree/list', params)

// 赠送套餐列表
export const productFree = (params = {}) => get('/productFree/free', params)

// 获取赠送套餐
export const getProductFree = (params = {}) => get('/productFree/get', params)

// 保存赠送套餐
export const saveOrUpdateProductFreeBatch = (params = {}) => post('/productFree/saveOrUpdate', params)

// 修改单个赠送套餐
export const updateProductFree = (params = {}) => post('/productFree/update', params)

// 移除单个赠送套餐
export const removeProductFree = (params = {}) => get('/productFree/remove', params)


// 订单列表
export const orderList = (params = {}) => post('/order/list', params)
// 订单列表导出   
export const exportOrder = (params = {}) => post('/order/exportOrder', params)
// 佣金列表
export const commission = (params = {}) => post('/commission', params)
// 佣金导出
export const commissionExport = (params = {}) => post('/commission/export', params)
// 充值未激活的页面
export const cardRechargeList = (params = {}) => get('/cardRecharge/cardRechargeList', params)
// 激活充值未激活的卡
export const cardRechargeActivation = (params = {}) => post('/cardRecharge/cardRechargeActivation', params)
// 批量充值  
export const batchOrder = (params = {}) => post('/order/batchOrder', params)
// 首冲复充统计  
export const rechargeList = (params = {}) => post('/recharge/list', params)
// 导出复充统计
export const exportListRecharge = (params = {}) => post('/recharge/exportListRecharge', params)
// 复充的详情
export const rechargeInfo = (params = {}) => get('/recharge/info', params)
// 复充的详情列表  
export const rechargeRecord = (params = {}) => post('/recharge/record', params)
// 导出列表的数据
export const rechargeExport = (params = {}) => get('/recharge/export', params)
// 任务中心
export const missionList = (params = {}) => post('/mission/list', params)

// 删除任务中心
export const deleteTask = (params = {}) => get('/mission/delete', params)


// 卡实名列表
export const cardCertList = (params = {}) => post('/cardCert/cardCertList', params)
// 卡实名详情 
export const getCertRecord = (params = {}) => get('/cardCert/getCertRecord', params)
// 更改卡实名的状态 
export const changeCertRecordStatus = (params = {}) => post('/cardCert/changeCertRecordStatus', params)
// 卡详情的退款
export const orderRefundOrder = (params = {}) => post('/order/refundOrder', params)
// 卡详情套餐转移
export const orderTransferCardProduct = (params = {}) => post('/cardProduct/transferCardProduct', params)
// 批量卡套餐转移
export const batchTransferProduct = (params = {}) => post('/cardProduct/batchTransferProduct', params)

// 卡详情套餐作废
export const orderInvalidCardProduct = (params = {}) => post('/cardProduct/invalidCardProduct', params)
// 订单列表批量操作卡后的充值选中套餐带出价格
export const userRechargeProductInfo = (params = {}) => post('/product/userRechargeProductInfo', params)
//获取套餐价格
export const userSelectProductPrice = (params = {}) => get('/product/selectProductPrice', params)
// 计算价格
export const orderCheckBalance = (params = {}) => post('/order/checkBalance', params)
// 计算价格并出现支付二维码
export const orderRechargePayment = (params = {}) => post('/order/rechargePayment', params)
// 根据订单号查看订单是否支付
export const orderQueryRecharge = (params = {}) => get('/order/queryRecharge', params)
// 激活套餐
export const activeOrderInfo = (params = {}) => post('/order/activeOrderInfo', params)
// 重置手机号
export const cleanPhone = (params = {}) => get('/card/cleanPhone', params)

// 业务员
export const userSalesman = (params = {}) => get('/user/salesman', params)
// 登陆日志列表
export const logIndex = (params = {}) => post('/log/index', params)
// 卡详情的售后记录
export const cardSaleLog = (params = {}) => get('/card/saleLog', params)
// 平台到期提醒设置
export const notice = (params = {}) => post('/notice', params)
// 平台到期提醒设置详情
export const noticeInfo = (params = {}) => get('/notice/info', params)
// 消息中心列表
export const messageList = (params = {}) => post('/notice/message/list', params)
// 导航条未读消息数据
export const noticeMessage = (params = {}) => post('/notice/message', params)
//未读消息统计
export const noticeMessageCount = (params = {}) => get('/notice/message/count', params)

// 代理商到期提醒设置
export const saveOrUpdateUserNotice = (params = {}) => post('/notice/saveUpdate', params)
// 代理商到期提醒详情
export const userNoticeDetail = (params = {}) => get('/notice/detail', params)


// 任务中心代理商筛选
export const agentChildList = (params = {}) => get('/agent/agentChildList', params)
// 个人中心的自动续费开关
export const autoRenewal = (params = {}) => get('/person/autoRenewal', params)
// 自动续费卡列表
export const renewalIndex = (params = {}) => post('/userAuto/renewal/index', params)
// 用户单个开关自动续费
export const autoRenewalStatus = (params = {}) => post('/userAuto/renewal/autoRenewalStatus', params)
// 用户批量开关自动续费
export const autoRenewalStatusBatch = (params = {}) => post('/userAuto/renewal/autoRenewalStatusBatch', params)
// 获取代理商加油包套餐
export const refuelingPackage = (params = {}) => get('/agent/refuelingPackage', params)
// 自动续费的套餐续费
export const batchAutoRenewal = (params = {}) => post('/order/batchAutoRenewal', params)
// 流程实例分页查询
export const processInstance = (params = {}) => post('/workflow/processInstance', params)
// 历史流程分页查询
export const historicActivity = (params = {}) => post('/workflow/historicActivity', params)
// 获取流程实例图片
export const processInstanceImage = (params = {}) => get('/workflow/processInstanceImage', params)
// 历史流程列表展示
export const historicActivityInstance = (params = {}) => get('/workflow/historicActivityInstance', params)
// 附加单据
export const processData = (params = {}) => get('/workflow/processData', params)
// 附加表单数据
export const processFromData = (params = {}) => get('/workflow/processFromData', params)
// 历史任务分页查询
export const historicTaskInstance = (params = {}) => post('/workflow/historicTaskInstance', params)
// 个人待执行任务
export const workflowTask = (params = {}) => post('/workflow/task', params)
// 个人历史任务分页查询
export const historicTaskInstancePerson = (params = {}) => post('/workflow/historicTaskInstancePerson', params)
// 财务任务列表
export const workflowInvoice = (params = {}) => post('/workflow/invoice', params)
// 财务任务列表导出 废弃
export const workflowInvoiceExport = (params = {}) => post('/invoice/invoiceExport', params)
// 审批意见提交
export const submitTask = (params = {}) => post('/workflow/submitTask', params)
// 我发起的流程
export const historicActivityPerson = (params = {}) => post('/workflow/historicActivityPerson', params)
// 微信投诉列表
export const complainList = (params = {}) => post('/complain/list', params)
// 获取微信投诉率数据
export const complainCount = (params = {}) => get('/complain/count', params)
// 获取微信投诉详情
export const complainDetail = (params = {}) => get('/complain/detail', params)
// 获取微信投诉协商历史
export const complainConsultList = (params = {}) => get('/complain/consultList', params)
// 微信投诉消息回复
export const complainAnswerComplaint = (params = {}) => get('/complain/answerComplaint', params)
// 结束微信投诉
export const complainFinishComplaint = (params = {}) => get('/complain/finishComplaint', params)
// 立即更新微信投诉列表
export const complainUpdateList = (params = {}) => get('/complain/updateList', params)
// 退款的详情
export const refundDetail = (params = {}) => get('/refund/detail', params)
// 获取卡的套餐信息
export const cardProductQueryCardProduct = (params = {}) => get('/cardProduct/queryCardProduct', params)


// 提交退款
export const refundRefundOrder = (params = {}) => post('/refund/refundOrder', params)
// 退款订单是否开通自动续费
export const checkOrderAutoRenewal = (params = {}) => get('/refund/checkOrderAutoRenewal', params)
// 退款查询列表
export const refundList = (params = {}) => post('/refund/list', params)
// 设置收款账号信息
export const dictionaryPayList = (params = {}) => post('/dictionary/pay/list', params)
// 更新收款账号信息
export const dictionaryPayUpdate = (params = {}) => post('/dictionary/pay/update', params)
// 更新收款账号轮询状态
export const dictionaryPayUpdateWxPayStatus = (params = {}) => post('/dictionary/pay/updateWxPayStatus', params)

// 套餐扣款规则分页展示
export const autoDeductionProductPage = (params = {}) => post('/autoDeduction/productPage', params)
// 套餐扣款规则保存
export const saveProductRule = (params = {}) => post('/autoDeduction/saveProductRule', params)
// 编辑套餐扣款规则详情
export const autoDeductionProductInfo = (params = {}) => get('/autoDeduction/productInfo', params)
// 编辑套餐扣款规则的保存
export const autoDeductionUpdateProductRule = (params = {}) => post('/autoDeduction/updateProductRule', params)
// 餐扣款规则的删除
export const autoDeductionProductDelete = (params = {}) => get('/autoDeduction/productDelete', params)
// 状态扣款规则分页展示
export const autoDeductionStatusPage = (params = {}) => post('/autoDeduction/statusPage', params)
// 状态扣款规则保存
export const saveStatusRule = (params = {}) => post('/autoDeduction/saveStatusRule', params)
// 编辑状态扣款规则详情
export const autoDeductionStatusInfo = (params = {}) => get('/autoDeduction/statusInfo', params)
// 编辑状态扣款规则的保存
export const autoDeductionUpdateStatusRule = (params = {}) => post('/autoDeduction/updateStatusRule', params)
// 状态扣款规则删除
export const autoDeductionStatusRuleDelete = (params = {}) => get('/autoDeduction/statusRuleDelete', params)
// 套餐扣款规则列表不分页
export const autoDeductionProductList = (params = {}) => get('/autoDeduction/productList', params)
// 状态扣款规则列表不分页
export const autoDeductionStatusList = (params = {}) => get('/autoDeduction/statusList', params)
// 海芯流量卡设置新增
export const addUnBindCardRecord = (params = {}) => post('/outside/addUnBindCardRecord', params)
// 海芯流量卡列表
export const outsideList = (params = {}) => post('/outside/list', params)
// 海芯删除绑卡记录
export const delUnBindCardRecord = (params = {}) => get('/outside/delUnBindCardRecord', params)
// 流量卡设置导出
export const exportOutSideCard = (params = {}) => post('/outside/exportOutSideCard', params)
// 套餐管理
export const cardProductRecordList = (params = {}) => post('/cardProduct/recordList', params)
//批量查询转套餐数据
export const transferProductList = (params = {}) => post('/cardProduct/transferProductList', params)
// 卡套餐管理
export const cardProductPage = (params = {}) => post('/cardProduct', params)
// 套餐管理详情
export const cardProductDetail = (params = {}) => get('/cardProduct/detail', params)
// 修改套餐时间
export const cardChangeCardProductTime = (params = {}) => post('/cardProduct/changeCardProductTime', params)
// 流量池详情 =>tab切换数据
export const poolGetFlowPoolList = (params = {}) => get('/pool/getFlowPoolList', params)
// 流量池详情 =>基本信息
export const poolGetFlowPoolDetail = (params = {}) => get('/pool/getFlowPoolDetail', params)
// 流量池详情 =>查看卡的六个月用量
export const cardGetListPoolCardFlow = (params = {}) => get('/card/listPoolCardFlow', params)
// 流量池详情 =>修改峰值
export const changeFlowPoolLimit = (params = {}) => get('/pool/changeFlowPoolLimit', params)
// 流量池详情 =>成员信息
export const poolGetFlowPoolCardList = (params = {}) => post('/pool/getFlowPoolCardList', params)
// 流量池详情 =>成员信息导出
export const poolGetFlowPoolCardListExport = (params = {}) => get('/pool/getFlowPoolCardListExport', params)
// 流量池详情 =>池详情
export const poolGetFlowPoolRenewRecord = (params = {}) => get('/pool/getFlowPoolRenewRecord', params)
// 流量池详情 =>续费
export const poolRenewFlowPool = (params = {}) => post('/pool/renewFlowPool', params)
// 流量池详情 =>加油包
export const poolGetTotalTypePoolPack = (params = {}) => get('/pool/getTotalTypePoolPack', params)
// 流量池详情 =>加油包的确认
export const poolBuyPoolPack = (params = {}) => get('/pool/buyPoolPack', params)

// 流量池成员信息 =>备注
export const poolCardRemark = (params = {}) => post('/pool/poolCardRemark', params)
// 流量池详情 =>查询流量池所有卡
export const getPoolCardList = (params = {}) => post('/pool/getPoolCardList', params)
// 流量池详情 =>续约
export const poolRenewal = (params = {}) => post('/pool/renewal', params)

// 新增流量池
export const poolSavePool = (params = {}) => post('/pool/savePool', params)
// 编辑流量池
export const poolUpdatePool = (params = {}) => post('/pool/updatePool', params)
// 流量池列表
export const poolList = (params = {}) => post('/pool/list', params)
// 流量池编辑获取流量池信息
export const poolGetFlowPoolInfo = (params = {}) => get('/pool/getFlowPoolInfo', params)
// 流量池=>卡分配
export const poolAssignPoolCard = (params = {}) => post('/pool/assignPoolCard', params)
// 流量池=>卡回收
export const poolRecyclingPoolCard = (params = {}) => post('/pool/recyclingPoolCard', params)
// 流量池=>消费明细
export const userAssetDetailPoolList = (params = {}) => post('/userAssetDetailPool/list', params)
// 流量池=>下载消费记录
export const userAssetDetailPoolDown = (params = {}) => post('/userAssetDetailPool/poolDown', params)
//流量池回收
export const poolCardRecovery = (params = {}) => get('/pool/poolCardRecovery', params)

//更改流量池卡的状态
export const changePoolCardStatus = (params = {}) => get('/pool/changePoolCardStatus', params)

//池扣费周期账单
export const userAssetDetailPoolRecord = (params = {}) => get('/userAssetDetailPool/assetRecord', params)

export const userAssetDetailPoolCards = (params = {}) => post('/userAssetDetailPool/assetPoolCards', params)


// 发票管理=>发票状态列表
export const invoiceStatusAll = (params = {}) => get('/invoice/statusAll', params)
// 发票管理=>可开发票列表
export const invoiceList = (params = {}) => post('/invoice/list', params)
// 发票管理=>代理商可开发票列表
export const getInvoiceList = (params = {}) => get('/invoice/list', params)
// 发票管理=>开发票信息提交 
export const invoiceSaveInvoice = (params = {}) => post('/invoice/saveInvoice', params)
// 发票管理=>专票开票信息提交
export const invoiceSaveInvoiceCompany = (params = {}) => post('/invoice/saveInvoiceCompany', params)
// 发票管理 => 专票获取发票信息
export const invoiceUserInvoice = (params = {}) => get('/invoice/userInvoice', params)
// 发票管理 => 获取省市区连级
export const dictionaryTreeCity = (params = {}) => get('/dictionary/treeCity', params)
// 发票管理 => 获取发票提交的信息
export const invoiceDetail = (params = {}) => get('/invoice/detail', params)
// 发票管理 => 发票详情 => 发票子列表
export const invoiceChildList = (params = {}) => get('/invoice/invoiceChildList', params)
// 发票管理 => 发票详情 => 发票订单列表
export const invoiceOrderList = (params = {}) => get('/invoice/invoiceOrderList', params)
// 发票管理 => 发票详情 => 发票操作记录列表
export const invoiceOperationList = (params = {}) => post('/invoice/invoiceOperationList', params)
// 发票管理 => 发票合并
export const invoiceMerge = (params = {}) => post('/invoice/merge', params)
// 发票管理 => 发票审核
export const invoiceAudit = (params = {}) => post('/invoice/audit', params)
// 发票管理 => 发票审批
export const invoiceApprove = (params = {}) => post('/invoice/approve', params)
// 用户中心 => 用户列表
export const userWxList = (params = {}) => post('/user/wxList', params)

// 用户中心 => 用户绑定列表
export const userWxBindList = (params = {}) => post('/user/wxBindList', params)

// 用户中心 => 小程序用户列表
export const userWxMpList = (params = {}) => post('/user/wxMpList', params)
// 用户中心 => 小程序用户详情
export const wxMpUserInfo = (params = {}) => get('/user/wxMpUserInfo', params)
// 用户中心 => 小程序用户备注
export const addWxMpUserRemark = (params = {}) => post('/user/addWxMpUserRemark', params)

// 用户中心 => 兑换列表
export const integralExchangeList = (params = {}) => post('/integral/exchangeList', params)
// 用户中心 => 新增规则
export const saveIntegralExchangeProduct = (params = {}) => post('/integral/saveIntegralExchangeProduct', params)
// 用户中心 => 用户详情
export const wxUserInfo = (params = {}) => get('/user/wxUserInfo', params)
// 用户中心 => 用户备注
export const addWxUserRemark = (params = {}) => post('/user/addWxUserRemark', params)
// 用户中心 => 用户详情 => 绑卡列表
export const wxUserBindCardList = (params = {}) => get('/user/wxUserBindCardList', params)
// 用户中心 => 用户详情 => 订单列表 
export const wxUserOrderInfo = (params = {}) => get('/user/wxUserOrderInfo', params)
// 用户中心 => 用户详情 => 解绑卡列表 
export const wxUserBindCardRecordList = (params = {}) => get('/user/wxUserBindCardRecordList', params)
// 用户中心 => 用户详情 => 积分列表 
export const wxUserIntegralRecord = (params = {}) => get('/user/wxUserIntegralRecord', params)
// 用户中心 => 用户详情 => 备注列表
export const wxUserRemarkRecord = (params = {}) => get('/user/wxUserRemarkRecord', params)

//企业活动
export const userEnterpriseList = (params = {}) => post('/user/enterprise/listPage', params)
//企业活动修改坐席
export const updateUserEnterprise = (params = {}) => post('/user/enterprise/updateEnterprise', params)

//运营情况详细统计
export const userOrderDaylist = (params = {}) => post('/userOrderDay/list', params)
//运营情况详细统计导出
export const userOrderDayexport = (params = {}) => post('/userOrderDay/export', params)
//支付宝签约数据
export const agreementList = (params = {}) => post('/agreement/list', params)
//支付宝解约
export const agreementRemoveAgreement = (params = {}) => get('/agreement/removeAgreement', params)
//支付宝更新按钮
export const agreementQueryAgreement = (params = {}) => get('/agreement/queryAgreement', params)
//自动续费 => 续费详情
export const agreementAgreementDetail = (params = {}) => get('/agreement/agreementDetail', params)
//自动续费 => 订单列表
export const agreementAgreementOrderList = (params = {}) => get('/agreement/agreementOrderList', params)
//自动续费 => 扣款列表
export const agreementAgreementDebitList = (params = {}) => get('/agreement/agreementDebitList', params)
//自动续费 => 变更列表
export const agreementAgreementModifyList = (params = {}) => get('/agreement/agreementModifyList', params)

//收款账号额度 =>tab表格头部展示
export const sysTable = (params = {}) => post('/sys/table', params)
export const userAccount = (params = {}) => post('/user/account', params)
export const tableUpdateUserTable = (params = {}) => post('/sys/table/updateUserTable', params)
export const accountInfos = (params = {}) => get('/user/account/infos', params) //收款账号


// 平台设置 个性化提交数据
export const platformCustom = (params = {}) => post('/user/platform/custom', params)
// 平台设置 个性化获取数据
export const getPlatformCustom = (params = {}) => get('/user/platform/custom', params)


export const backUser = (params = {}) => get('/user/backUser', params)

// 管理员保存平台
export const saveUpdatePlatform = (params = {}) => post('/platform/saveUpdatePlatform', params)
export const platformDetail = (params = {}) => get('/platform/platformDetail', params)
export const wxConfig = (params = {}) => post('/platform/wechat/type', params)
export const adminPlatformList = (params = {}) => get('/platform/adminPlatformList', params)
export const payConfigSource = (params = {}) => post('/pay/config/list', params)

// 平台设置 公众号模板配置
export const wechatCustom = (params = {}) => post('/user/wechat/custom', params)
// 平台设置 公众号模板配置获取信息
export const getWechatCustom = (params = {}) => get('/user/wechat/custom', params)
// 平台设置 接入微信【企业付款到零钱】提交证书
export const wechatCert = (params = {}) => post('/user/wechat/cert', params)
// 平台设置 ip设置
export const platformIp = (params = {}) => post('/user/platform/ip', params)
// 平台设置 获取ip设置
export const getPlatformIp = (params = {}) => get('/user/platform/ip', params)
// 平台设置 通知提交
export const assetNotice = (params = {}) => post('/user/asset/notice', params)
// 平台设置 通知获取
export const getAssetNotice = (params = {}) => get('/user/asset/notice', params)
//平台列表
export const platformPage = (params = {}) => post('/platform/list', params)
//平台微信列表
export const wechatPage = (params = {}) => post('/platform/wechat/list', params)

export const payConfigList = (params = {}) => get('/platform/pay/config', params)

export const saveOrUpdateWxAndPay = (params = {}) => post('/platform/saveOrUpdateWxAndPay', params)

export const mchIdByAppId = (params = {}) => get('/platform/mchIdByAppId', params)

// 机卡检测
export const refreshCardLock = (params = {}) => get('/card/refreshCardLock', params)
//机卡解绑
export const unLockCard = (params = {}) => get('/card/unLockCard', params)


// 风控卡列表
export const controlCardList = (params = {}) => post('/card/control/list', params)
export const removeControlCard = (params = {}) => post('/card/control/removeControlCard', params)
export const exportControlCard = (params = {}) => post('/card/control/export', params)
export const batchControlCard = (params = {}) => post('/card/control/batchCards', params)
//卡比例列表
export const cardRatioList = (params = {}) => post('/card/ratio/list', params)
export const batchCardFlowRatio = (params = {}) => post('/card/ratio/batchCards', params)
export const resetCardFlowRatio = (params = {}) => post('/card/ratio/resetCardFlowRatio', params)
export const updateCardFlowRatio = (params = {}) => post('/card/ratio/update', params)
export const cardFlowRatioRecord = (params = {}) => get('/card/ratio/record', params)
export const exportCardFlowRatio = (params = {}) => post('/card/ratio/export', params)
//销卡列表
export const cancelCardList = (params = {}) => post('/cancelCard/list', params)
export const removeCancelCard = (params = {}) => post('/cancelCard/removeCancelCard', params)
export const exportCancelCard = (params = {}) => post('/cancelCard/export', params)
//批量添加销卡
export const  cancelBatchCards = (params = {})=>post('/cancelCard/batchCards',params)



export const warningPage = (params = {}) => post('/warning/index', params)
export const warningCardPage = (params = {}) => post('/warning/detail', params)
export const warningMessagePage = (params = {}) => post('/warning/result', params)

//用户统计数据
export const panelCardData = (params = {}) => get('/user/data/cardData', params)
export const panelLineCardData = (params = {}) => get('/user/data/cardLineData', params)

export const panelOrderData = (params = {}) => get('/user/data/orderData', params)
export const panelOrderLineData = (params = {}) => get('/user/data/orderLineData', params)
export const cardSourceData = (params = {}) => get('/user/data/cardSourceData', params)
export const cardAgentData = (params = {}) => get('/user/data/cardAgentData', params)
export const cardOperatorData = (params = {}) => get('/user/data/cardOperatorData', params)

export const userRechargeData = (params = {}) => get('/user/data/rechargeDayData', params)


export const smsRecordIndex = (params = {}) => post('/message/smsIndex', params)

//财务管理
export const userWithdrawInfo = (params = {}) => get('/commission/userWithdrawInfo', params)
//收款账号绑定
export const userAccountNumberValidate = (params = {}) => get('/userAccountNumber/validate', params)
//收款账号绑定验证码全发送
export const userAccountBind = (params = {}) => get('/sms/userAccountBind', params)
//微信收款账号绑定
export const userAccountWxQrCode = (params = {}) => get('/userAccountNumber/qrcode', params)
//微信收款账号绑定结果查询
export const bindWxResult = (params = {}) => get('/userAccountNumber/bindWxResult', params)
//微信收款账号详细信息查询
export const userAccountNumberDetail = (params = {}) => get('/userAccountNumber/userAccountNumberDetail', params)

//支付宝账号保存
export const saveUserAlipay = (params = {}) => post('/userAccountNumber/bindAlipay', params)


//银行收款账号详细信息查询
export const userBankDetail = (params = {}) => get('/user/bank/userBankDetail', params)
//收款账号列表
export const userAccountNumberList = (params = {}) => get('/userAccountNumber/userAccountNumberList', params)
//可提现明细列表
export const userCommissionWithdrawList = (params = {}) => post('/commission/userCommissionWithdraw', params)
//可提现明细统计
export const countCommissionWithdraw = (params = {}) => post('/commission/countCommissionWithdraw', params)
//用户提现信息
export const userWithdrawalApplicationInfo = (params = {}) => get('/commission/userWithdrawalApplicationInfo', params)
//用户提现信息上传
export const saveUserWithdrawal = (params = {}) => post('/commission/saveUserWithdrawal', params)
//用户提现信息列表
export const pageUserWithdrawal = (params = {}) => post('/commission/pageUserWithdrawal', params)

//用户提现审核
export const withdrawalAudit = (params = {}) => post('/commission/withdrawalAudit', params)


//用户提现详情
export const userWithdrawalDetail = (params = {}) => get('/commission/userWithdrawalDetail', params)


//用户提现验证
export const sendWithdrawalSms = (params = {}) => get('/sms/sendWithdrawalSms', params)

//用户提现佣金列表
export const withdrawalCommissionPage = (params = {}) => post('/withdrawalCommission/page', params)

//用户提现佣金列表导出
export const withdrawalCommissionExport = (params = {}) => get('/withdrawalCommission/export', params)

//用户提现订单记录
export const withdrawalOrderPage = (params = {}) => post('/user/withdrawalOrder/index', params)
//佣金明细
export const countCommission = (params = {}) => post('/commission/countCommission', params)
//佣金概览统计
export const countWithdrawalCommission = (params = {}) => get('/statistic/countWithdrawalCommission', params)
//佣金按周统计
export const countWithdrawalCommissionWeek = (params = {}) => get('/statistic/countWithdrawalCommissionWeek', params)
//佣金折线图
export const lineWithdrawalCommission = (params = {}) => get('/statistic/lineWithdrawalCommission', params)

//代理商卡统计
export const agentCardStatistic = (params = {}) => get('/statistic/agentCardStatistic', params)

//收款账号收款统计
export const payAccountList = (params = {}) => post('/statistic/payAccountListChart', params)


//用户提现费率
export const withdrawalRatePage = (params = {}) => post('/user/withdrawalRate/index', params)
//费率保存修改
export const saveOrUpdateRate = (params = {}) => post('/user/withdrawalRate/saveOrUpdate', params)

//用户费率查询
export const userWithdrawalRate = (params = {}) => get('/user/withdrawalRate/userWithdrawalRate', params)

//套餐限制列表查询
export const productLimitPage = (params = {}) => post('/user/productLimit/index', params)
//套餐限制保存
export const saveProductLimit = (params = {}) => post('/user/productLimit/save', params)
//套餐限制修改
export const updateProductLimit = (params = {}) => post('/user/productLimit/update', params)
//套餐限制删除
export const productLimitRemove = (params = {}) => get('/user/productLimit/remove', params)
//套餐列表查询
export const productsByUserId = (params = {}) => get('/product/productsByUserId', params)

//套餐模板
export const smsTemplateList = (params = {}) => get('/smsTemplate/list', params)

//套餐模板详情
export const smsTemplateDetail = (params = {}) => get('/smsTemplate/detail', params)
//代理商发送短信
export const sendUserMesaage = (params = {}) => post('/sms/userSendMessage', params)

//卡分配
export const cardDistribution = (params) => post('/cardDistribution', params)
//卡分配导出
export const exportCardDistribution = (params) => post('/cardDistribution/exportCardDistribution', params)
//用户分配数据统计
export const userDistributionPage = (params) => post('/user/distribution/index', params)

// 短信中心-短信模块
export const simSmsTemplateList = (params = {}) => post('/simSmsTemplate/list', params)
export const simSmsTemplateAdd = (params = {}) => post('/simSmsTemplate/add', params)
export const simSmsTemplateDetail = (params = {}) => get('/simSmsTemplate/detail', params)
export const simSmsTemplateUpdate = (params = {}) => post('/simSmsTemplate/update', params)
export const simSmsTemplateDelete = (params = {}) => get('/simSmsTemplate/delete', params)
export const simSmsTemplateAudit = (params = {}) => post('/simSmsTemplate/audit', params)
export const simSmsTemplateAll = (params = {}) => get('/simSmsTemplate/all', params)
// SIM卡已发短信记录
export const simSmsSentList = (params = {}) => post('/simSmsRecord/sentList', params)
// SIM卡已收短信记录
export const simSmsReceivedList = (params = {}) => post('/simSmsRecord/receivedList', params)
// SIM卡发送短信
export const simSmsSendSms = (params = {}) => post('/simSms/sendSms', params)
// SIM卡群发短信
export const simSmsBatchSms = (params = {}) => post('/simSms/batchSms', params)

//日志管理-登录日志
export const loginLogRecord = (params = {}) => post('/loginLog/index', params)
//日志管理-操作日志
export const operLogRecord = (params = {}) => post('/log/index', params)

export const visitorLog = (params = {}) => post('/visitorLog/index', params)

export const statisticsVisitorLog = (params = {}) => post('/visitorLog/statisticsVisitorLog', params)

//监控中心
//监控中心 - 在线用户
export const onlineList = (params = {}) => post('/monitor/online/list', params)
export const forceLogout = (params = {}) => get('/monitor/online/forceLogout', params)

//流量记录
//日流量
export const cardFlowDay = (params = {}) => post('/card/flow/day', params)
export const exportFlowDay = (params = {}) => post('/card/flow/day/export', params)
export const cardFlowMonth = (params = {}) => post('/card/flow/month', params)
export const exportFlowMonth = (params = {}) => post('/card/flow/month/export', params)
//单卡月流量记录
export const cardMonthFlow = (params = {}) => get('/card/flow/cardMonthFlow', params)

// 规则管理
// 限速规则
// 限速规则分页展示
export const productFLowSpeedRulesList = (params = {}) => post('/rule/productSpeed', params)
// 限速规则展示
export const productSpeedList = (params = {}) => post('/rule/productSpeedList', params)
//查找可设置限速套餐
export const selectSpeedRuleAndProducts = (params = {}) => get('/rule/selectSpeedRuleAndProducts', params)
//设置限速套餐
export const updateProductSpeedProductIds = (params = {}) => post('/rule/updateProductSpeedProductIds', params)

//限速规则取消套餐
export const delProductFlowRule = (params = {}) => get('/rule/delProductFlowRule', params)
// 限速规则保存
export const productFLowSpeedRulesAdd = (params = {}) => post('/rule/saveProductSpeed', params)
// 编辑限速规则详情
export const productFLowSpeedRulesDetail = (params = {}) => get('/rule/productSpeedInfo', params)
// 编辑限速规则的修改
export const productFLowSpeedRulesUpdate = (params = {}) => post('/rule/updateProductSpeed', params)
//限速规则的删除
export const productFLowSpeedRulesDelete = (params = {}) => get('/rule/productSpeedDelete', params)

//限速规则查询
export const listSpeedRule = (params = {}) => get('/rule/listSpeedRule', params)


// 帮助中心-帮助模块
export const helpList = (params = {}) => post('/help/list', params)
export const helpAdd = (params = {}) => post('/help/add', params)
export const helpDetail = (params = {}) => get('/help/detail', params)
export const helpUpdate = (params = {}) => post('/help/update', params)
export const helpDelete = (params = {}) => get('/help/delete', params)


// 数据字典记录列表
export const dataDictionaryRecordList = (params = {}) => post('/dataDictionaryRecord/list', params)
// 数据字典列表
export const dataDictionaryList = (params = {}) => post('/dataDictionary/list', params)
// 数据字典根列表
export const dataDictionaryParentAll = (params = {}) => post('/dataDictionary/parentAll', params)
export const delDataDictionary = (params = {}) => get('/dataDictionary/delete', params)
export const addDataDictionary = (params = {}) => post('/dataDictionary/save', params)
export const updateDataDictionary = (params = {}) => post('/dataDictionary/update', params)
export const getDataDictionary = (params = {}) => get('/dataDictionary/detail', params)

//区域限制模块
//区域限制离列表
export const  cardRegionList = (params = {})=>post('/card/region/list',params)
//批量添加区域限制卡
export const  regionBatchCards = (params = {})=>post('/card/region/batchCards',params)
//移除区域卡
export const  removeCardRegion = (params = {})=>post('/card/region/removeCardRegion',params)
//批量刷新区域
export const  refreshBatchCardRegion = (params = {})=>post('/card/region/refreshBatchCardRegion',params)
//刷新当前区域
export const  refreshCardRegion = (params = {})=>get('/card/region/refreshCardRegion',params)
//导出区域限制卡
export const exportRegionCard = (params = {}) => post('/card/region/export', params)

//通道模块
//添加通道
export const addChannel = (params) => post('channel/addChannel', params)
//获取通道列表分页
export const listPageChannel = (params) => post('channel/listPage', params)
//获取通道详情
export const getChannel = (params) => get('channel/getChannel', params)
//修改通道
export const updateChannel = (params) => post('channel/updateChannel', params)
//删除通道
export const delChannel = (params) => post('channel/delChannel', params)

//获取通道列表
export const listChannel = (params) => post('/channel/list', params)

//请求日志
export const requestLogList = (params) => get('requestLog/info', params)

// 卡试用申请
//获取卡试用申请列表
export const listPageCardTrial = (params) => post('cardTrial/list', params)
//客服审核
export const cardTrialAudit = (params = {}) => post('cardTrial/audit', params)
//保存快递信息
export const cardTrialExpress = (params = {}) => post('cardTrial/express', params)
//获取卡试用申请详情
export const getCardTrial = (params) => get('cardTrial/detail', params)
// 卡试用申请详情-卡列表
export const cardTrialCardList = (params = {}) => post('cardTrial/cardList', params)
// 卡试用申请详情-操作列表
export const cardTrialOperationList = (params = {}) => post('cardTrial/operationList', params)
// 卡试用申请备注
export const cardTrialSaveRemark = (params = {}) => post('cardTrial/saveRemark', params)

// 流量池运营情况
// 流量池运营情况-停机警告list
export const stopWarnPage = (params) => post('/statisticPool/stopWarnPage', params)
// 流量池运营情况-运营统计
export const totalStatisticData = (params = {}) => get('/statisticPool/totalStatisticData', params)
// 流量池运营情况-卡运营商分布
export const cardOperatorPieData = (params = {}) => get('/statisticPool/cardOperatorPieData', params)
// 流量池运营情况-卡生命周期分布
export const lifeCyclePieData = (params = {}) => get('/statisticPool/lifeCyclePieData', params)
// 流量池运营情况-月入池卡数统计
export const cardNumberByMonthBarData = (params = {}) => get('/statisticPool/cardNumberByMonthBarData', params)
// 流量池运营情况-近六月费用
export const sixMonthsExpenseBarData = (params = {}) => get('/statisticPool/sixMonthsExpenseBarData', params)
// 流量池运营情况-流量使用量
export const flowUsageData = (params = {}) => get('/statisticPool/flowUsageData', params)
// 流量池运营情况-卡月流量TOP
export const cardMonthFlowTopData = (params = {}) => get('/statisticPool/cardMonthFlowTopData', params)
// 流量池运营情况-本月流量使用情况
export const currentMonthFlowData = (params = {}) => get('/statisticPool/currentMonthFlowData', params)
// 流量池运营情况-历史用量
export const historyUsageData = (params = {}) => get('/statisticPool/historyUsageData', params)

//卡异常列表
export const cardExceptionPage = (params = {}) => post('/cardException/exception/list', params)
export const cardExceptionStatus = (params = {}) => post('/cardException/exception/status', params)
export const cardExceptionExport = (params = {}) => post('/cardException/export', params)

//底价方案保存
export const saveBaseScheme = (params = {}) => post('/scheme/saveBaseScheme', params)
//底价方案列表
export const baseSchemeList = (params = {}) => post('/scheme/list', params)
//自建底价方案
export const baseSchemeAll = (params = {}) => get('/scheme/selectAll', params)

//下级底价方案列表
export const baseSchemeSubList = (params = {}) => post('/scheme/subList', params)
//下级底价方案套餐列表
export const baseSchemeProductSubList = (params = {}) => get('/scheme/product/schemeProduct', params)
//下级底价方案未分配卡片
export const baseSchemeCard = (params = {}) => post('/scheme/card/schemeCard', params)
//下级底价方案保存
export const subSaveBaseScheme = (params = {}) => post('/scheme/subSaveBaseScheme', params)
//下级底价方案详情
export const schemeDetail = (params = {}) => get('/scheme/schemeDetail', params)
//底价方案修改
export const editBaseScheme = (params = {}) => post('/scheme/editBaseScheme', params)
//下级底价方案修改
export const editSubBaseScheme = (params = {}) => post('/scheme/editSubBaseScheme', params)

//方案代理商
export const schemeAgentList = (params = {}) => get('/scheme/schemeAgentList', params)


//比例方案保存
export const saveRatioScheme = (params = {}) => post('/ratio/scheme/saveScheme', params)
//比例方案查询
export const selectRatioSchemeList = (params = {}) => get('/ratio/scheme/selectList', params)
//比例方案修改套餐
export const updateRatioSchemeProduct = (params = {}) => post('/ratio/scheme/updateSchemeProduct', params)
//比例方案修改卡片
export const updateRatioSchemeCard = (params = {}) => post('/ratio/scheme/addRatioSchemeCard', params)
//查询比例方案卡片列表
export const pageCards = (params = {}) => post('/ratio/scheme/pageCards', params)

//删除比例方案卡片
export const deleteRatioSchemeCard = (params = {}) => post('/ratio/scheme/deleteRatioSchemeCard', params)
//删除比例方案
export const deleteRatioScheme = (params = {}) => get('/ratio/scheme/deleteRatioScheme', params)

//查询客户信息列表
export const selectCustomerInformationList =(params ={}) => post('/customer/information/list',params)

// 卡操作类型
export const cardOperationType = (params = {}) => get('/card/operation/types', params)

//新增客户信息
export const insertCustomerInfo =(params ={}) => post('/customer/information/insert',params)
//查询客户信息详情
export const getCustomerInfo =(params ={}) => get('/customer/information/detail',params)
//编辑客户信息
export const updateCustomerInfo =(params ={}) => post('/customer/information/update',params)
//保存客户提交流程
export const submitFlowCustomer =(params ={}) => post('/customer/information/submitFlowCustomer',params)
//刪除客户信息
export const delCustomerInfo =(params ={}) => get('/customer/information/del',params)
//获取当前登录人创建的客户
export const loginUserCustomerList =(params ={}) => get('/customer/information/loginUserCustomerList',params)

//查询发货申请列表
export const shipmentList =(params ={}) => post('/shipment/page',params)
//查询发货申请详情
export const findShipmentRequestById =(params ={}) => get('/shipment/findShipmentRequestById',params)
//新增发货申请页面
export const insertShipment =(params ={}) => post('/shipment/addShipment',params)
//修改发货申请页面
export const updateShipment =(params ={}) => post('/shipment/editShipment',params)
//刪除发货申请
export const delShipment =(params ={}) => get('/shipment/delShipment',params)
//作废发货申请
export const invalidShipment =(params ={}) => get('/shipment/invalidBill',params)
//保存发货并提交流程
export const submitAndFlowShipment =(params ={}) => post('/shipment/submitAndFlowShipment',params)
//发货申请任务个数
export const reviewShipmentCount =(params ={}) => get('/shipment/reviewShipmentCount',params)
//修改发货申请主表
export const updateShipmentRequest = (params ={}) => post('/shipment/update',params)

//查询出库单详情
export const outEntrepotByShipmentId =(params ={}) => get('/outEntrepot/detailByShipmentId',params)
//导出出库单
export const exportOutEntrepot =(params ={}) => post('/outEntrepot/exportExcel',params)
//查询出库单列表
export const outEntrepotList =(params ={}) => post('/outEntrepot/page',params)
//出库单详情
export const outEntrepotDetailById =(params ={}) => get('/outEntrepot/detail',params)
//作废出库单
export const invalidOutEntrepot =(params ={}) => get('/outEntrepot/invalidBill',params)
//保存出库单并提交流程
export const submitAndFlowOutEntrepot = (params ={}) => post('/outEntrepot/submitAndFlowOutEntrepot',params)
//保存出库单及明细
export const saveOutEntrepot = (params ={}) => post('/outEntrepot/save',params)
//编辑出库单及明细
export const editOutEntrepot = (params ={}) => post('/outEntrepot/edit',params)
//出库单反馈物流
export const submitOutEntrepotLogistic =(params ={}) => post('/outEntrepot/submitLogistic',params)
//出库单反馈付款
export const submitPaymentRmk =(params ={}) => post('/outEntrepot/paymentRmk',params)
//出库单申请任务个数
export const reviewEntrepotCount =(params ={}) => get('/outEntrepot/reviewEntrepotCount',params)


//客户留言列表
export const clientNoteList =(params ={}) => post('/clientNote/pageList',params)
//ESIM卡激活邮件发送记录列表
export const esimMailRecordList =(params ={}) => post('/esimMailRecord/pageList',params)
//SIM卡邮寄物流记录列表
// export const simLogisticRecordList =(params ={}) => post('/simLogisticRecord/pageList',params)
//SIM卡邮寄物流更新
export const submitSimLogistic =(params ={}) => post('/simLogisticRecord/update',params)

//支付宝商户配置信息
export const alipayRelationList =(params ={}) => post('/alipayRelation/pageList',params)
export const alipayRelationDetail =(params ={}) => get('/alipayRelation/detail',params)
export const submitAlipayRelation =(params ={}) => post('/alipayRelation/submit',params)
//修改支付宝限额状态
export const changeAlipayStatus =(params ={}) => get('/alipayRelation/changeStatus',params)
//切换支付宝收款账号
export const switchAliPay =(params ={}) => get('/alipayRelation/switchPay',params)

//定向信息列表
export const orientationList =(params ={}) => post('/orientation/list',params)
export const saveOrientationBatch =(params ={}) => post('/orientation/saveBatch',params)
export const updateOrientation =(params ={}) => post('/orientation/update',params)
export const exportOrientation =(params ={}) => post('/orientation/export',params)
export const batchUpdateOrientation =(params ={}) => post('/orientation/batchUpdate',params)
export const delOrientation =(params ={}) => get('/orientation/del',params)

//定时任务列表
export const taskList =(params ={}) => get('/task/list',params)
export const taskStart =(params ={}) => get('/task/start',params)
export const taskStop =(params ={}) => get('/task/stop',params)

export const taskFlowImport =(params ={}) => post('/task/flow/import',params)

//方案公司
export const serviceProviderList =(params ={}) => post('/sys/provider/list',params)
export const serviceProviderListAll =(params ={}) => get('/sys/provider/listAll',params)
export const saveServiceProvider =(params ={}) => post('/sys/provider/save',params)
export const updateServiceProvider =(params ={}) => post('/sys/provider/update',params)
export const removeServiceProvider =(params ={}) => get('/sys/provider/remove',params)
















































































